import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { ReactNode } from "react";

type DocsTableProps = {
  headers: string[];
  rows: ReactNode[][];
  mt?: number;
  mb?: number;
};

export default function DocsTable({ headers, rows, mt = 10, mb=10 }: DocsTableProps) {
  return (
    <TableContainer boxShadow={"lg"} mt={mt} mb={mb} w="full">
      <Table>
        <Thead>
          <Tr>
            {headers.map((h) => (
              <Th key={h}>{h}</Th>
            ))}
          </Tr>
        </Thead>
        <Tbody bg="#edf2f7">
          {rows.map((row, i) => (
            <Tr key={i}>
              {row.map((cell, j) => (
                <Td key={j} verticalAlign="top">
                  {cell}
                </Td>
              ))}
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
}

